module.exports = __webpack_public_path__ + "static/assets/ebcf9cf22ed4c3bbd8fecf2abbb612e3.svg";